import type { CreateOperationParams } from "@forgepoint/shared";
import Decimal from "decimal.js";

export function calculateProductionRate(
  params: Pick<CreateOperationParams, "cost" | "burdenRate">,
): string {
  return toDecimalOrZero(params.cost)
    .plus(toDecimalOrZero(params.burdenRate))
    .toString();
}

function toDecimalOrZero(value: string | null | undefined): Decimal {
  try {
    return new Decimal(value || 0);
  } catch {
    return new Decimal(0);
  }
}
